import wpService from '../../../services/wordpress.js'

// const QA_TYPE = 'common'

export default {
  // よくあるご質問 を 取得します。エーシンクはアウェイトを待って実行されます。
  async getQuestionAnswers({ commit }) {
    // トライ
    try {
      // ローディングアイコンを出す状態にする
      commit('SET_QUESTION_ANSWER_LOADING', true)
      // axiosですべてのよくあるご質問を取得する
      const res = await wpService.getQuestionAnswerAll()
      // console.log('下')
      // console.log(res.data)
      commit('FETCH_QUESTION_ANSWERS', res.data)
    // エラーをキャッチしたら
    } catch (e) {
      // 空っぽのデータで埋める
      commit('FETCH_QUESTION_ANSWERS', [])
    }
    // ローディングアイコンをオフる
    commit('SET_QUESTION_ANSWER_LOADING', false)
  },

  setCurrentId({ commit }, id) {
    // console.log(id)
    commit('SET_CURRENT_ID', id)
  },

  async getCategories({ commit }) {


    try {

      const res = await wpService.getCategories()
      commit('SET_CATEGORY', res.data)

    } catch (e) {

      commit('SET_CATEGORY', [])
      
    }
  },

  setIsOpended({ commit }, id) {
    commit('SET_ISOPENED', id)
  }
}
